<script setup>
import {  setLogoutAPI } from '@/apis/user'
import { useUserStore } from '@/stores/userStore';
import { useRouter } from 'vue-router';
import { onMounted, ref, reactive } from 'vue'
import { useI18n } from 'vue-i18n'
const { t, locale } = useI18n();
const userStore = useUserStore()
const router = useRouter()
const goLogin = () => {
    if (userStore.userInfo.token) return;
    router.push('/login')
    localStorage.setItem('loginType',1)
}
const quit = () => {
    ElMessageBox.confirm(t('home2' ), t('home3' ), {
    confirmButtonText: t('home4' ),
    cancelButtonText: t('home5' ),
    type: "warning",
    lockScroll: false,
  }).then(async () => {
    const res = await setLogoutAPI();
    console.log()
        if (res.code == 0) {
            // 1. 清除用户信息 触发action
            userStore.clearUserInfo()
            // 2. 跳转到登录页
            router.push('/login')
        }
  })
   
}
const formData = reactive({

    userform: {
        avatar: null,
        fansNum: null,
        nickname: null,
        identity: null,
        mobile: '',
        email: '',
        password: '',
    }

})
const getUser = async () => {
    userStore.getUser()
    formData.userform = userStore.userInfo
   
}
onMounted(() => {
    if(userStore.userInfo.token){
        getUser()
    }
   
    
});

</script>

<template>
    <div class="cart" @click="goLogin">
        <div class="avatar">
            <img v-if="userStore.userInfo.token" :src="userStore.userInfo.avatar" alt="" srcset="">
            <div v-else class="loginBut">
                login
            </div>
        </div>
        <div class="layer" v-if="userStore.userInfo.token">
            <div class="list">
                <div class="avatar">
                    <img :src="userStore.userInfo.avatar ||'https://shopfile.51siteboost.com/shap-head-test/20250304/1741069084714129479.png'" alt="" srcset="">
                </div>
                <div class="list-user">
                    <!-- <svg-icon icon-class="zuanshi" v-if="userStore.userInfo.sellerType == 1"/> -->
                    <div class="text-ellipsis">{{ userStore.userInfo.nickname }}</div>
                </div>
                <div class="divBr"></div>
                <div class="list-type">
                    <div class="type">
                        <div class="type-num">
                            {{ userStore.userInfo.fansNum }}
                        </div>
                        <div class="type-name">
                            {{ $t("home6") }}
                        </div>
                    </div>
                    <div class="type">
                        <div class="type-num">
                            {{ userStore.userInfo.followPersonNum }}
                        </div>
                        <div class="type-name">
                            {{ $t("home7") }}
                        </div>
                    </div>
                </div>
                <div class="divBr"></div>
                <div class="item" @click="$router.push('/member')">
                    <div class="item-value">
                       {{ $t("home8") }}
                    </div>
                </div>
                <div class="item" @click="$router.push('/member/MallOrder')">
                    <div class="item-value">
                       {{ $t("setup449") }}
                    </div>
                </div>
                <div class="item" @click="$router.push('/member/PurchasingOrder')">
                    <div class="item-value">
                        {{ $t("setup456") }}
                    </div>
                </div>
                <div class="item" @click="$router.push('/member/sell')">
                    <div class="item-value">
                       {{ $t("home10") }}
                    </div>
                </div>
                <div class="item" @click="$router.push('/member/wallet')">
                    <div class="item-value">
                       {{ $t("home11") }}
                    </div>
                </div>
                <div class="divBr"></div>
                <div class="quit" @click="quit()">
                    {{ $t("home12") }}
                </div>

            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.cart {
    width: 60px;
    position: relative;
    z-index: 600;
    margin-left: 5px;

    .avatar {


        text-align: center;
        position: relative;
        display: block;


        img {
            // width: 100%;
            // height: 100%;
            border-radius: 50%;
            width: 40px;
            height: 40px;
            object-fit: cover;
        }

        .loginBut {
            color: #fff;
            height: 32px;
            border-radius: 32px;
            display: flex;
            align-items: center;
            justify-content: center;
            background: linear-gradient(330deg, #56a9ff 0%, #f56c6c 100%);


        }



    }

    &:hover {
        .layer {
            opacity: 1;
            transform: none;
        }
    }

    .layer {
        opacity: 1;
        transition: all 0.4s 0.2s;
        transform: translateY(-100px) scale(1, 0);
        width: 300px;
        // height: 200px;
        position: absolute;
        top: 54px;
        right: -30px;
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
        background: #fff;
        border-radius: 4px;
        padding-top: 10px;

        &::before {
            content: "";
            position: absolute;
            right: 55px;
            top: -5px;
            width: 13px;
            height: 14px;
            background: #fff;
            transform: scale(0.6, 1) rotate(45deg);
            box-shadow: -3px -3px 5px rgba(0, 0, 0, 0.1);
        }


    }

    .list {
            // height: 310px;
            overflow: auto;
            padding: 0 10px;
            .avatar {

            margin-top: 20px;
            text-align: center;
            position: relative;
            display: block;


            img {
                // width: 100%;
                // height: 100%;
                border-radius: 50%;
                width: 59px;
                height: 59px;
                object-fit: cover;
            }

    .loginBut {
        color: #fff;
        height: 32px;
        border-radius: 32px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: linear-gradient(330deg, #56a9ff 0%, #f56c6c 100%);


    }



    }

        .list-user {
            padding: 12px 0 15px 0;
            font-family: MicrosoftYaHei, MicrosoftYaHei;
            font-weight: bold;
            font-size: 16px;
            color: #11192D;
            line-height: 16px;
            text-align: center;
            font-style: normal;
            width: 280px;
            .text-ellipsis {
                text-align: center;
                width: 280px;
                overflow: hidden; /* 隐藏超出部分 */
                white-space: nowrap; /* 保持文案在一行显示 */
                text-overflow: ellipsis; /* 显示省略号 */
                // width: 18ch; /* 限制宽度为20个字符 */
                }
        }

        .divBr {
            background-color: #e8e8ed;
            height: 1px;
        }

        .iconsize {
            margin-right: 7px;
        }

        .list-type {
            display: flex;
            justify-content: space-around;
            padding: 10px 0;

            .type {
                display: flex;
                flex-direction: column;
                align-items: center;
                .type-num {
                    font-family: MicrosoftYaHei, MicrosoftYaHei;
                    font-weight: bold;
                    font-size: 16px;
                    color: #FC3938;
                    line-height: 16px;
                 
                    font-style: normal;
                }

                .type-name {
                    padding-top: 8px;
                    font-family: MicrosoftYaHei;
                    font-size: 14px;
                    color: #888888;
                    line-height: 14px;
                    text-align: left;
                    font-style: normal;
                }
            }
        }

        .item {
            padding-top: 15px;
            text-align: center;
            .item-value {
                padding-top: 15px;
                font-size: 15px;
                padding: 0 15px 15px 10px;
                display: flex;
                flex-direction: row;
                align-items: center;
                font-family: MicrosoftYaHei;
                font-size: 14px;
                color: #1F1F1F;
                line-height: 14px;
                text-align: left;
                font-style: normal;
                justify-content: center;

            }

            &:hover {
                background: #FFF1EB;
                border-radius: 4px;
                font-family: MicrosoftYaHei;
                font-size: 14px;
               
                line-height: 14px;
                text-align: center;
                font-style: normal;
                .item-value{
                    color: #FC3938;
                }
            }
        }

        .quit {
            padding: 20px 0;
            margin-bottom: 10px;
            font-family: MicrosoftYaHei;
            font-size: 14px;
            color: #888888;
            line-height: 14px;
            text-align: center;
            font-style: normal;

            &:hover {

                background: #FFF1EB;
                border-radius: 4px;
                font-family: MicrosoftYaHei;
                font-size: 14px;
                color: #FC3938;
                line-height: 14px;
                text-align: center;
                font-style: normal;
            }
        }


    }
}

/* 响应式设计 */
@media (max-width: 768px) {
    .app-header .cart {
        width: 55px !important;
    }

    .cart {
        margin-left: 0px;

        .avatar {
            img {
                width: 30px;
                height: 30px;
            }

            .loginBut {
                height: 25px;
            }
        }

        .layer {
            opacity: 0;
            transition: all 0.4s 0.2s;
            transform: translateY(-100px) scale(1, 0);
            width: 120px;
            top: 40px;
            right: -6px;
            padding-top: 10px;

            &::before {
                content: "";

                right: 27px;
                top: -8px;
                width: 13px;
                height: 14px;

            }


        }
    }

    .list {
        padding: 0 5px;

        .list-user {
            font-size: 16px !important;
            padding: 5px !important;
            text-align: center;
        }

        .divBr {
            background-color: #e8e8ed;
            height: 1px;
        }

        .iconsize {
            margin-right: 7px;
        }

        .list-type {
            display: flex;
            justify-content: space-around;
            padding: 5px 0;

            .type {
                .type-num {
                    font-size: 16px !important;
                }

                .type-name {
                    color: #999aaa;
                    font-size: 12px !important;

                }
            }
        }

        .item {
            padding-top: 10px !important;

            .item-value {
                padding-top: 10px !important;
                font-size: 12px !important;
                padding: 0 10px 10px 10px !important;
                display: flex;
                flex-direction: row;
                align-items: center;

            }

            &:hover {

                background-color: #f0f0f5;
            }
        }

        .quit {
            margin-bottom: 10px;
            padding: 10px 10px !important;
            font-size: 12px !important;

            &:hover {

                background-color: #f0f0f5;
            }
        }


    }
}
</style>